export const prod = true;
// export const url = '//api3.app.99maiyou.com';
export const url = '//api.mlgamebox.my16api.com/';
// export const url = 'http://coat0914.heigu.com';
// export const url = '//h5.api3.99maiyou.com';